import { Component, signal, computed, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Sidebar } from "../../shared/components/sidebar/sidebar";
import { Header } from "../../shared/components/header/header";
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-main-layout',
  imports: [RouterOutlet, Sidebar, Header],
  templateUrl: './main-layout.html',
  styleUrl: './main-layout.css',
})
export class MainLayout implements OnInit {
  private readonly authService = inject(AuthService);

  ngOnInit(): void {
    this.fetchUserProfile();
  }

  /**
   * Fetches the latest user profile data to ensure roles and permissions are up to date.
   */
  private fetchUserProfile(): void {
    this.authService.getProfile().subscribe({
      next: (response) => {
        // Profile update is handled by the tap operator in authService.getProfile()
      },
      error: (err) => {
        console.error('Failed to sync user profile:', err);
      }
    });
  }
}
